import { render, staticRenderFns } from "./MobileAppRename.vue?vue&type=template&id=377ed3aa&"
import script from "./MobileAppRename.vue?vue&type=script&lang=js&"
export * from "./MobileAppRename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports